import { all, fork } from 'redux-saga/effects'
import postsSaga from './news/sagas'
import categoriesSaga from './categories/sagas'
import tagsSaga from './tags/sagas'
import latestPostsSaga from './latestNews/latestNews.sagas'

export default function* rootSaga() {
  yield all([
    fork(postsSaga),
    fork(latestPostsSaga),
    fork(categoriesSaga),
    fork(tagsSaga)
  ])
}
